// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"c7892e2a","468":"8902f5b5","587":"0d271e06","787":"9bc2fa63"}[chunkId] + ".chunk.js";
};